export const containsNumberRegex = new RegExp("[0-9]");
export const defaultAspNetIdentity = new RegExp("^(?=.*[a-z])(?=.*\\d)(?=.*[^a-zA-Z\\d]).{8,}$");

export const containsNumber: RegWithError = { regex: containsNumberRegex, errorText: "register.atLeastOneNumber" };
export const containsSpecialCharecter: RegWithError = { regex: new RegExp("[^a-zA-Z0-9]"), errorText: "register.specialCharacter" };
export const containsLetter: RegWithError = { regex: new RegExp("[a-zA-Z]"), errorText: "register.atLeastOneLetter" };
export const atLeastXLong: RegWithError = { regex: new RegExp(".{8,}"), errorText: "register.8orMoreCharacters" };

export const phoneNumberRegex: RegExp = new RegExp("^[0-9()--+/ ]+$");


export interface RegWithError {
  regex: RegExp;
  errorText: string;
}
